import { MutationTree } from 'vuex';
import { State } from './state';
import {
  Banker,
  LeadsApiOptions,
  SetLeadFieldValuePayload,
  SingleLead,
  SingleLeadOverviewResponse,
} from './types';

export enum LeadsMutationsType {
  SET_LEADS_LOADING = 'SET_LEADS_LOADING',
  SET_LEADS = 'SET_LEADS',
  SET_LEADS_SETTINGS = 'SET_LEADS_SETTINGS',
  SET_NEW_LEADS_COUNT = 'SET_NEW_LEADS_COUNT',
  CLEAR_LEADS_STATE = 'CLEAR_LEADS_STATE',
  SET_BANKERS = 'SET_BANKERS',
  SET_BANKERS_LOADING = 'SET_BANKERS_LOADING',
  SET_LEAD = 'SET_LEAD',
  SET_LEAD_LOADING = 'SET_LEAD_LOADING',
  SET_LEAD_FIELD_VALUE = 'SET_LEAD_FIELD_VALUE',
  CLEAR_INDIVIDUAL_LEAD_STATE = 'CLEAR_INDIVIDUAL_LEAD_STATE',
}

export type Mutations<S = State> = {
  [LeadsMutationsType.SET_LEADS_LOADING](state: S, payload: boolean): void;
  [LeadsMutationsType.SET_LEADS](
    state: S,
    payload: { leads: SingleLeadOverviewResponse[]; count: number }
  ): void;
  [LeadsMutationsType.SET_LEADS_SETTINGS](
    state: S,
    payload: LeadsApiOptions
  ): void;
  [LeadsMutationsType.SET_NEW_LEADS_COUNT](state: S, payload: number): void;
  [LeadsMutationsType.CLEAR_LEADS_STATE](state: S): void;
  [LeadsMutationsType.SET_BANKERS](state: S, payload: Array<Banker>): void;
  [LeadsMutationsType.SET_BANKERS_LOADING](state: S, payload: boolean): void;
  [LeadsMutationsType.SET_LEAD](state: S, payload: SingleLead): void;
  [LeadsMutationsType.SET_LEAD_LOADING](state: S, payload: boolean): void;
  [LeadsMutationsType.SET_LEAD_FIELD_VALUE](
    state: S,
    payload: SetLeadFieldValuePayload
  ): void;
  [LeadsMutationsType.CLEAR_INDIVIDUAL_LEAD_STATE](state: S): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [LeadsMutationsType.SET_LEADS_LOADING](state, payload) {
    state.loading = payload;
  },
  [LeadsMutationsType.SET_LEADS](state, payload) {
    state.leads = payload.leads;
    state.totalResultCount = payload.count;
  },
  [LeadsMutationsType.SET_LEADS_SETTINGS](state, payload) {
    state.settings = payload;
  },
  [LeadsMutationsType.SET_NEW_LEADS_COUNT](state, payload) {
    state.newLeadsCount = payload;
  },
  [LeadsMutationsType.CLEAR_LEADS_STATE](state) {
    state.loading = false;
    state.leads = [];
  },
  [LeadsMutationsType.SET_BANKERS](state, payload) {
    state.bankers = payload;
  },
  [LeadsMutationsType.SET_BANKERS_LOADING](state, payload) {
    state.bannkersLoading = payload;
  },
  [LeadsMutationsType.SET_LEAD](state, payload) {
    state.lead = payload;
  },
  [LeadsMutationsType.SET_LEAD_LOADING](state, payload) {
    state.leadLoading = payload;
  },
  [LeadsMutationsType.SET_LEAD_FIELD_VALUE](state, payload) {
    const lead = state.lead;
    const field = lead[payload.field];

    if (field) {
      if (payload.field === 'serviceOfInterest') {
        lead.serviceOfInterest = (payload.value as string[]).map(value => ({
          dataType: 'string',
          dataValue: value,
        }));
      } else {
        field.dataValue = payload.value;
      }
    }
  },
  [LeadsMutationsType.CLEAR_INDIVIDUAL_LEAD_STATE](state) {
    state.lead = {} as SingleLead;
    state.leadLoading = false;
  },
};
